/* yeye arcade — global.js
   Shopify cart AJAX, predictive search, nav/dropdown/cookie, scroll reveal,
   and pixel-art placeholders for products without photos. */
(function () {
  "use strict";
  var RM = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  /* ---------------- pixel-art placeholders ---------------- */
  function cssVar(n) { return getComputedStyle(document.documentElement).getPropertyValue(n).trim() || "#F984CA"; }
  var PAL;
  function buildPal() { PAL = { pink: cssVar("--accent"), c2: cssVar("--accent-2"), yel: cssVar("--accent-3"), gry: cssVar("--accent-4"), ink: cssVar("--text") }; }
  function rng(seed) { var s = (seed || 1) >>> 0; return function () { s = (s * 1664525 + 1013904223) >>> 0; return s / 4294967296; }; }
  function sprite(ctx, map, legend, px, ox, oy) {
    for (var y = 0; y < map.length; y++) { var row = map[y]; for (var x = 0; x < row.length; x++) { var ch = row[x]; if (ch === "." || ch === " ") continue; var col = legend[ch]; if (!col) continue; ctx.fillStyle = col; ctx.fillRect(ox + x * px, oy + y * px, px, px); } }
  }
  function dither(ctx, W, H, a, b) {
    var bayer = [[0, 8, 2, 10], [12, 4, 14, 6], [3, 11, 1, 9], [15, 7, 13, 5]];
    for (var y = 0; y < H; y++) for (var x = 0; x < W; x++) { var t = y / H; ctx.fillStyle = (bayer[y % 4][x % 4] / 16 < t) ? b : a; ctx.fillRect(x, y, 1, 1); }
  }
  var STK = {
    cat: ["..H..H..", ".HHHHHH.", "H.o..o.H", "H..HH..H", "HHHHHHHH", ".H.HH.H.", "........"],
    ghost: [".HHHH.", "HHHHHH", "HoHHoH", "HHHHHH", "HHHHHH", "H.HH.H"],
    star: ["...H...", "...H...", "HHHHHHH", ".HHHHH.", "..H.H..", ".H...H."],
    heart: [".H.H.", "HHHHH", "HHHHH", ".HHH.", "..H.."],
    flower: [".P.P.", "PPPPP", ".PYP.", "PPPPP", ".P.P."],
    diamond: ["..H..", ".HHH.", "HHHHH", ".HHH.", "..H.."],
    face: ["HHHHH", "HoHoH", "HHHHH", "Ho.oH", "HHHHH"],
    moon: [".HHH.", "HH...", "H....", "H....", "HH...", ".HHH."]
  };
  var KEYS = Object.keys(STK);
  function scheme(seed) { var c = [PAL.pink, PAL.c2, PAL.yel, PAL.gry]; return c; }
  function paintSheet(cv, seed, mode) {
    var W = 48, H = 48; cv.width = W; cv.height = H; var ctx = cv.getContext("2d"); ctx.imageSmoothingEnabled = false;
    var rnd = rng(seed), cols = scheme(seed), INK = PAL.ink, YEL = PAL.yel;
    dither(ctx, W, H, "#ffffff", "#ffe9f5");
    if (mode === "detail") {
      var dk = KEYS[(seed + 2) % KEYS.length], dcol = cols[(seed + 1) % cols.length], dm = STK[dk];
      var dr = dm.length, dc = 0; for (var ii = 0; ii < dm.length; ii++) dc = Math.max(dc, dm[ii].length);
      var dpx = Math.max(2, Math.floor(Math.min(W * 0.6 / dc, H * 0.6 / dr))), dox = Math.floor((W - dc * dpx) / 2), doy = Math.floor((H - dr * dpx) / 2);
      var dirs = [[-1, 0], [1, 0], [0, -1], [0, 1]];
      for (var d = 0; d < 4; d++) sprite(ctx, dm, { H: INK, o: INK, P: INK, Y: INK }, dpx, dox + dirs[d][0], doy + dirs[d][1]);
      sprite(ctx, dm, { H: dcol, o: INK, P: dcol, Y: YEL }, dpx, dox, doy);
      sprite(ctx, STK.star, { H: YEL }, 2, 7, 8); sprite(ctx, STK.star, { H: YEL }, 2, W - 13, H - 15);
      return;
    }
    var cells = [[6, 6], [26, 5], [7, 24], [27, 25], [16, 15], [33, 32], [5, 38], [30, 12]];
    for (var i = 0; i < cells.length; i++) {
      var key = KEYS[(seed + i * 3) % KEYS.length], col = cols[(seed + i) % cols.length];
      var off = [[-1, 0], [1, 0], [0, -1], [0, 1]];
      for (var k = 0; k < 4; k++) sprite(ctx, STK[key], { H: INK, o: INK, P: INK, Y: INK }, 1, cells[i][0] + off[k][0], cells[i][1] + off[k][1]);
      sprite(ctx, STK[key], { H: col, o: INK, P: col, Y: YEL }, 1, cells[i][0], cells[i][1]);
      sprite(ctx, STK.star, { H: YEL }, 1, cells[i][0] + STK[key][0].length, cells[i][1]);
    }
  }
  var COIN = [".YYYY...", "YooooY..", "YoYYoY..", "YoYYoY..", "YoYYoY..", "YooooY..", ".YYYY...", "........"];
  function paintCoin(cv) { cv.width = 8; cv.height = 8; var ctx = cv.getContext("2d"); ctx.imageSmoothingEnabled = false; sprite(ctx, COIN, { Y: PAL.yel, o: PAL.ink }, 1, 0, 0); }
  function paintAll(scope) {
    scope = scope || document;
    $all("canvas[data-ph]", scope).forEach(function (cv) { paintSheet(cv, (parseInt(cv.getAttribute("data-ph"), 10) || 3) % 9973, null); });
    $all("canvas[data-ph-detail]", scope).forEach(function (cv) { paintSheet(cv, (parseInt(cv.getAttribute("data-ph-detail"), 10) || 3) % 9973, "detail"); });
    $all("canvas[data-icon='coin']", scope).forEach(paintCoin);
  }

  /* ---------------- nav drawer + shop dropdown ---------------- */
  function toggleNav(s) { var d = $("#navDrawer"), o = $("#navOv"); if (d) { d.classList.toggle("open", s); if (o) o.classList.toggle("open", s); } }
  function closeDD() { $all(".navdd.open").forEach(function (x) { x.classList.remove("open"); var b = $("[data-dd-toggle]", x); if (b) b.setAttribute("aria-expanded", "false"); }); }

  /* ---------------- cart drawer (AJAX) ---------------- */
  var drawerOn = !!$("#cartDrawer");
  function openCart() { var d = $("#cartDrawer"), o = $("#cartOv"); if (d) { d.classList.add("open"); if (o) o.classList.add("open"); } }
  function closeCart() { var d = $("#cartDrawer"), o = $("#cartOv"); if (d) { d.classList.remove("open"); if (o) o.classList.remove("open"); } }
  function setCount(n) { $all("[data-cart-count]").forEach(function (el) { el.textContent = n; el.hidden = (n === 0); }); }
  function refreshCart() {
    return fetch(ROOT + "?section_id=cart-drawer").then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, "text/html");
      var fresh = doc.querySelector("#cartDrawer");
      var cur = $("#cartDrawer");
      if (fresh && cur) { cur.innerHTML = fresh.innerHTML; paintAll(cur); }
    }).then(function () { return fetch(ROOT + "cart.js").then(function (r) { return r.json(); }); }).then(function (c) { if (c) setCount(c.item_count); });
  }
  function addToCart(form) {
    var btn = form.querySelector('[type="submit"]'); var label = btn ? btn.innerHTML : "";
    if (btn) { btn.disabled = true; }
    return fetch(ROOT + "cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.status) { throw new Error(d.description || "Could not add"); }
        if (btn) { btn.innerHTML = "✓ ADDED"; setTimeout(function () { btn.innerHTML = label; btn.disabled = false; }, 1100); }
        return refreshCart();
      })
      .then(function () { if (drawerOn) openCart(); else window.location.href = ROOT + "cart"; })
      .catch(function (e) { if (btn) { btn.innerHTML = label; btn.disabled = false; } alert(e.message); });
  }
  function changeQty(key, qty) {
    return fetch(ROOT + "cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) })
      .then(function () { return refreshCart(); });
  }

  /* ---------------- search (predictive) ---------------- */
  function openSearch() { var o = $("#searchOv"); if (o) { o.classList.add("open"); var i = $("#searchInput"); if (i) { i.value = ""; i.focus(); } var r = $("#searchResults"); if (r) r.innerHTML = ""; } }
  function closeSearch() { var o = $("#searchOv"); if (o) o.classList.remove("open"); }
  var sTimer;
  function runSearch(q) {
    var box = $("#searchResults"); if (!box) return;
    q = (q || "").trim();
    if (!q) { box.innerHTML = ""; return; }
    fetch(ROOT + "search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=show")
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var items = (data.resources && data.resources.results && data.resources.results.products) || [];
        if (!items.length) { box.innerHTML = '<p class="search-empty">' + (window.YEYE_NO_RESULTS || "NO RESULTS — TRY ANOTHER WORD ✶") + "</p>"; return; }
        box.innerHTML = '<div class="grid">' + items.map(function (p) {
          var img = (p.featured_image && p.featured_image.url) || (p.image) || "";
          var price = p.price ? (Number(p.price)).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : "";
          var art = img ? '<img class="card-main" src="' + img + '&width=600" alt="" loading="lazy">' : '<canvas class="px card-main" data-ph="' + (p.id || 3) + '"></canvas>';
          var soldout = (p.available === false) ? '<span class="srch-tag">SOLD OUT</span>' : '';
          return '<div class="card"><a class="card-link" href="' + p.url + '"><div class="card-art"><div class="card-art__in">' + art + soldout + '</div></div>' +
            '<div class="card-info"><div class="card-type">' + (p.type || "") + '</div><div class="card-foot"><span class="card-name">' + p.title + '</span><span class="price"><span class="euro-coin">€</span>' + price + '</span></div></div></a></div>';
        }).join("") + "</div>";
        paintAll(box);
      }).catch(function () { });
  }

  /* ---------------- cookie ---------------- */
  function hideCookie() { var c = $("#cookieBar"); if (c) c.classList.add("hide"); }

  /* ---------------- delegated events ---------------- */
  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-nav-open]")) { toggleNav(true); return; }
    if (e.target.closest("[data-nav-close]")) { toggleNav(false); }
    var ddt = e.target.closest("[data-dd-toggle]"); if (ddt) { e.preventDefault(); var pp = ddt.closest(".navdd"); var op = pp.classList.toggle("open"); ddt.setAttribute("aria-expanded", op ? "true" : "false"); if (op) syncArt(pp); return; }
    if (!e.target.closest(".navdd")) closeDD();

    var co = e.target.closest("[data-cart-open]"); if (co && drawerOn) { e.preventDefault(); openCart(); return; }
    if (e.target.closest("[data-cart-close]")) { closeCart(); return; }
    if (e.target.id === "cartOv") { closeCart(); return; }
    var cq = e.target.closest("[data-cart-q]"); if (cq) { var pr = cq.getAttribute("data-cart-q").split("|"); changeQty(pr[0], parseInt(pr[1], 10)); return; }
    var crm = e.target.closest("[data-cart-rm]"); if (crm) { changeQty(crm.getAttribute("data-cart-rm"), 0); return; }

    if (e.target.closest("[data-search-open]")) { e.preventDefault(); openSearch(); return; }
    if (e.target.closest("[data-search-close]")) { closeSearch(); return; }
    if (e.target.id === "searchOv") { closeSearch(); return; }

    var ck = e.target.closest("[data-cookie]"); if (ck) { try { localStorage.setItem("yeye_cookie", ck.getAttribute("data-cookie")); } catch (x) {} hideCookie(); return; }
  });

  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { toggleNav(false); closeCart(); closeSearch(); closeDD(); } });

  document.addEventListener("submit", function (e) {
    var f = e.target;
    if (f.matches('form[action$="/cart/add"], form[data-product-form]')) { e.preventDefault(); addToCart(f); }
  });

  document.addEventListener("input", function (e) {
    if (e.target.id === "searchInput") { clearTimeout(sTimer); var v = e.target.value; sTimer = setTimeout(function () { runSearch(v); }, 220); }
  });

  /* ---------------- product: qty / gallery / variants ---------------- */
  function fmtMoney(cents) { try { return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }); } catch (x) { return (cents / 100).toFixed(2); } }
  document.addEventListener("click", function (e) {
    var q = e.target.closest("[data-q]");
    if (q) { var inp = q.parentNode.querySelector("input"); var mn = parseInt(inp.min || "1", 10); inp.value = Math.max(mn, (parseInt(inp.value, 10) || mn) + parseInt(q.getAttribute("data-q"), 10)); return; }
    var th = e.target.closest("[data-thumb]");
    if (th) { var g = th.closest("[data-gallery]"); var main = g && g.querySelector("[data-gallery-main] img"); if (main) main.src = th.getAttribute("data-thumb"); if (g) $all(".pdp-thumb", g).forEach(function (x) { x.classList.remove("is-on"); }); th.classList.add("is-on"); return; }
  });
  document.addEventListener("change", function (e) {
    var pick = e.target.closest("[data-variant-picker]"); if (!pick) return;
    var data = pick.querySelector("[data-variant-json]"); if (!data) return;
    var variants; try { variants = JSON.parse(data.textContent); } catch (x) { return; }
    $all("[data-option-index]", pick).forEach(function (g) { $all(".opt", g).forEach(function (l) { l.classList.toggle("is-on", l.querySelector("input").checked); }); });
    var sel = $all("[data-option-index]", pick).map(function (g) { var c = g.querySelector("input:checked"); return c ? c.value : null; });
    var match = null;
    for (var i = 0; i < variants.length; i++) { var ok = true; for (var j = 0; j < sel.length; j++) { if (variants[i].options[j] !== sel[j]) { ok = false; break; } } if (ok) { match = variants[i]; break; } }
    if (!match) return;
    var form = pick.closest("form"); var idEl = form && form.querySelector("[data-variant-id]"); if (idEl) idEl.value = match.id;
    var btn = $("[data-add-btn]"); if (btn) { if (match.available) { btn.disabled = false; btn.textContent = "▶ ADD TO CART"; } else { btn.disabled = true; btn.textContent = "SOLD OUT"; } }
    var pe = $("[data-price]"); if (pe) { pe.innerHTML = '<span class="euro-coin">€</span> ' + fmtMoney(match.price); }
    if (match.featured_image && match.featured_image.src) {
      var fsrc = match.featured_image.src;
      var gm = $("[data-gallery-main]"); var mimg = gm && gm.querySelector("img");
      if (mimg) { mimg.src = fsrc + (fsrc.indexOf("?") > -1 ? "&" : "?") + "width=1000"; mimg.style.transform = ""; }
      var base = fsrc.split("?")[0];
      $all(".pdp-thumb").forEach(function (t) { t.classList.toggle("is-on", (t.getAttribute("data-thumb") || "").split("?")[0] === base); });
    }
  });

  /* ---------------- product main image hover-zoom ---------------- */
  function initZoom() {
    if (!(window.matchMedia && window.matchMedia("(hover: hover)").matches)) return;
    $all(".pdp-main").forEach(function (box) {
      box.addEventListener("mousemove", function (e) {
        var img = box.querySelector("img"); if (!img) return;
        var r = box.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        img.style.transformOrigin = x + "% " + y + "%";
        img.style.transform = "scale(2.3)";
      });
      box.addEventListener("mouseleave", function () {
        var img = box.querySelector("img"); if (!img) return;
        img.style.transform = ""; img.style.transformOrigin = "center";
      });
    });
  }

  /* ---------------- init ---------------- */
  function pickMenuArt() {
    $all("[data-menu-art]").forEach(function (box) {
      var imgs = $all(".navdd__rand", box);
      if (imgs.length < 2) return;
      var pick = Math.floor(Math.random() * imgs.length);
      imgs.forEach(function (im, i) { im.style.display = i === pick ? "block" : "none"; });
    });
  }
  function syncArt(nd) {
    var list = $(".navdd__list", nd), box = $(".navdd__img", nd);
    if (list && box) box.style.height = list.offsetHeight + "px";
  }
  function initMenuArt() {
    if (!(window.matchMedia && window.matchMedia("(hover: hover)").matches)) return;
    $all(".navdd").forEach(function (nd) {
      var t;
      nd.addEventListener("mouseenter", function () {
        clearTimeout(t);
        nd.classList.add("open");
        if ($(".navdd__img", nd)) syncArt(nd);
      });
      nd.addEventListener("mouseleave", function () {
        clearTimeout(t);
        t = setTimeout(function () { nd.classList.remove("open"); }, 260);
      });
    });
  }
  function init() {
    buildPal();
    paintAll(document);
    initZoom();
    pickMenuArt();
    initMenuArt();
    try { if (localStorage.getItem("yeye_cookie") !== null) hideCookie(); } catch (x) {}
    if (("IntersectionObserver" in window) && !RM && document.body.classList.contains("reveal-on")) {
      var secs = $all("#MainContent > section, #MainContent .section");
      secs.forEach(function (s, i) { if (i > 0) s.classList.add("reveal"); });
      var obs = new IntersectionObserver(function (es) { es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); obs.unobserve(en.target); } }); }, { threshold: 0.1, rootMargin: "0px 0px -6% 0px" });
      $all(".reveal").forEach(function (s) { obs.observe(s); });
    }
    var rt; window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(function () { buildPal(); paintAll(document); }, 200); });
  }
  if (document.readyState !== "loading") init(); else document.addEventListener("DOMContentLoaded", init);
})();
